import { IVideoWidget } from "@common/models/CMS/VideoWidget";
import Icon from "@components/general/Icon";
import { getFilePath, IViewport } from "@config/appConfig";
import { store } from "@misc/Reducer";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { FC, useRef, useState } from "react";

interface IVideoWidgetProps {
    dataSource: IVideoWidget;
    autoPlay?: boolean;
}

const VideoWidget: FC<IVideoWidgetProps> = ({ dataSource, autoPlay }) => {
    const { tr } = Translate;
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playControlsVisible, setPlayControlsVisible] = useState<boolean>(true);

    const onPlayControlsClick = () => {
        videoRef.current?.play();
        setTimeout(() => {
            videoRef.current?.setAttribute("controls", "true");
        }, 300)
        setPlayControlsVisible(false);
    }

    return (
        <div className="video-widget">
            {
                dataSource.sources?.paths.length ?
                    <div className="video-widget-container">
                        <video
                            ref={videoRef}
                            autoPlay={autoPlay}
                            muted={autoPlay}
                            className="video-widget-source"
                            width="100%"
                            height="100%"
                            poster={dataSource.cover?.paths.length ? getFilePath(renderSourceBaseOfDevice(dataSource.cover.paths)) : ""}
                            controls={!playControlsVisible}
                        >
                            <source src={getFilePath(renderSourceBaseOfDevice(dataSource.sources.paths))} type="video/mp4" />
                            {tr("msg_not_support_video")}
                        </video>
                        <div className={`video-widget-play-controls flex flex-center justify-center${!playControlsVisible ? " hide" : ""}`} >
                            <div className="video-widget-play-controls-container flex">
                                <Icon name="icon-paly-video" onClick={() => onPlayControlsClick()} />
                            </div>
                        </div>
                    </div>
                    : ""
            }
            {
                dataSource.description?.html ? <div className="video-widget-decsription" dangerouslySetInnerHTML={{ __html: dataSource.description.html }} /> : ""
            }
        </div>
    )
}

export default VideoWidget;

export const renderSourceBaseOfDevice = (paths: string[]): string => {
    const width = store.getState().windowWidth;
    const { small, medium } = Config.get<IViewport>("viewport");
    if (paths.length)
        return width > medium ? paths[0]
            : width > small ? paths[Math.floor(paths.length / 2)]
                : paths[paths.length - 1];
    return "";
}